<mat-card>



    <mat-card-content>
        <div>
            <div  style="background: url('../../assets/img/morceau/titre.png');height: 60px; background-size: 100% 100%;z-index: 99999;
                 width: 100%;color: #2F4395; font-size: 18px;">

                <div style="float: left;margin-top:5px;">
                    <img src="../../assets/img/morceau/3.png" height="40">
                    Facturation
                </div>
                <div style="float: right; cursor: pointer;" [routerLink]="[ '/invoices',{idClient:selectedClient.idClient} ]" routerLinkActive="router-link-active" >
                    <img src="../../assets/img/morceau/edit.png">
                </div>

            </div>

            <div   >

                <div   class="titles1">
                    <div class="label">
                        N° Contrat
                    </div>

                    <div class="label">
                        Devise
                    </div>

                    <div class="label">
                        Proforma/Devis
                    </div>

                    <div class="label">
                        Factures
                    </div>
                    <div class="label">
                        Total Factures
                    </div>
                    <div class="label">
                        Encaissement
                    </div>
                    <div class="label">
                        Reste

                    </div>




                </div>





                <div class="content1">

                    <div style="text-decoration: underline;cursor: pointer;"  (click)="getClientContract(true)" class="labeltext">
                        {{nContrat}}
                    </div>
                    <div class="labeltext">
{{devise | uppercase}}
                    </div>
                    <div  class="labeltext" >
                        {{nContrat}}
                    </div>
                    <div class="labeltext">

                        {{nFactures}}
                    </div>

                    <div class="labeltext">

                        {{totalFactures | currency:' ':'code'}}
                    </div>
                    <div class="labeltext">

                        {{totalPaiement | currency:' ':'code'}}
                    </div>
                    <div class="labeltext">

                        {{solde | currency:' ':'code'}}
                    </div>
                </div>






            </div>

        </div>


    </mat-card-content>






    <mat-card-content *ngIf="false">





        <div class="row">

            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Total Factures" [value]='totalFactures'>
                </mat-form-field>
            </div>

            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Encaissement" [value]="totalPaiement">
                </mat-form-field>
            </div>
            <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
                <mat-form-field class="example-full-width">
                    <input matInput placeholder="Reste" [value]="solde">
                </mat-form-field>
            </div>
        </div>



    </mat-card-content>
</mat-card>